module.exports = __webpack_public_path__ + "img/number-thumb-21.e16a6991.jpg";